var map = {
	"./de.json": "dz79",
	"./en.json": "EMRA",
	"./fr.json": "xixM",
	"./id.json": "ZcGm",
	"./ja.json": "0yeD",
	"./ko.json": "puLf",
	"./ms.json": "wTtq",
	"./th.json": "fXDH",
	"./vi.json": "IrYT",
	"./zh-cn.json": "Fqqz",
	"./zh-hant.json": "0d/9",
	"./zh-hk.json": "/VTa",
	"./zh-tw.json": "A+Fn"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "KJ7G";